export default angular.module("ScriptService", []).factory("Scripts", [
  "$http",
  "$rootScope",
  "$filter",
  "Flash",
  function ($http, $rootScope, $filter, Flash) {
    const scripts = [];

    const loading = {
      scripts: false,
      scriptmeta: false,
      scriptsummary: false,
      scriptevidence: false,
      scriptcontent: false,
    };

    // Load all scripts from the database
    function loadScripts(statusInfo, callback) {
      loading.scripts = true;
      $http
        .get(`/api/scripts/?status=${statusInfo}`)
        .success((data, status) => {
          for (let i = 0; data.length > i; i++) {
            data[i].EDITED = (data[i].EDITED_AT || data[i].EDITED).substring(0, 10);
          }
          // Angular copy so that the change is noticed in Controller and 2-way binding works
          angular.copy(data, scripts);
          if (callback) {
            callback(status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(status);
          }
        })
        .finally(() => {
          loading.scripts = false;
        });
    }

    // Load one selected script from the database
    function loadScriptMetaByID(scriptID, callback) {
      loading.scriptmeta = true;
      $http
        .get(`/api/scripts/${scriptID}`)
        .success((data, status) => {
          data.FOUNDED = data.FOUNDED.substring(0, 10);
          data.EDITED = (data.EDITED_AT || data.EDITED).substring(0, 10);

          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptmeta = false;
        });
    }

    function loadAuditLogById(resourceId, callback) {
      $http
        .get(`/api/audit/${resourceId}`)
        .success((data, status) => {
          callback(data, status);
        })
        .error((data, status) => {
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    }

    // Load one selected script status history from the database
    function loadScriptStatusHistoryByID(scriptID, callback) {
      $http
        .get(`/api/scripts/${scriptID}/status/history`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    }

    // Load one selected script summary from the database
    function loadScriptSummaryByID(scriptID, lang, callback) {
      loading.scriptsummary = true;
      $http
        .get(`/api/scripts/${scriptID}/summaries/${lang}`)
        .success((data, status) => {
          let cleandata = "";
          if (data) {
            cleandata = data[0];
          }
          if (callback) {
            callback(cleandata, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptsummary = false;
        });
    }

    const loadScriptMetadataHistoryByType = (type, rowID, scriptID, callback) => {
      $http
        .get(`/api/scripts/${scriptID}/summaries/${rowID}/${type.toLowerCase()}/history`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    };

    // Load one selected script risk from the database
    function loadScriptRiskByID(scriptID, callback) {
      loading.scriptsummary = true;
      $http
        .get(`/api/scripts/${scriptID}/risks`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptsummary = false;
        });
    }

    // Load one selected script (graded) evidence from the database
    function loadScriptEvindenceByID(scriptID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/scripts/${scriptID}/evidences`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script (graded) evidence text from the database
    function loadScriptEvindenceTextByID(evdID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/texts/evidences/${evdID}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script cochrane review from the database
    function loadScriptCochraneByID(scriptID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/scripts/${scriptID}/cochranes`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script cochrane title text from cochranes.com
    function loadScriptCochraneTextByID(evdID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/texts/cochranes/${evdID}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script EBM Guidelines from the database
    function loadScriptEBMGuidelinesByID(scriptID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/scripts/${scriptID}/guidelines`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script EBM guidelines text from the database
    function loadScriptEBMGuidelinesTextByID(evdID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/texts/guidelines/${evdID}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script Journal articles from the database
    function loadScriptJournalArticlesByID(scriptID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/scripts/${scriptID}/journals`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script Journal articles text from xml
    function loadScriptJournalArticlesTextByID(evdID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/texts/journals/${evdID}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script www links from the database
    function loadScriptWWWlinksByID(scriptId, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/scripts/${scriptId}/www_links`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script www links from the database
    function loadScriptOtherEvidenceByID(scriptID, callback) {
      loading.scriptevidence = true;
      $http
        .get(`/api/scripts/${scriptID}/conventions`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptevidence = false;
        });
    }

    // Load one selected script summary from the database
    function loadScriptReturningMessagesByID(scriptID, lang, callback) {
      loading.scriptcontent = true;
      $http
        .get(`/api/scripts/${scriptID}/messages/${lang}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptcontent = false;
        });
    }

    const loadScriptMessageHistory = (typeName, rowID, scriptID, lang, callback) => {
      const type = typeName.toLowerCase();
      $http
        .get(`/api/scripts/${scriptID}/messages/${rowID}/${type}/history?lang=${lang}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    };

    // Load one selected script code aliases from the database
    function loadScriptCodeAliasesByID(scriptID, callback) {
      loading.scriptcontent = true;
      $http
        .get(`/api/scripts/${scriptID}/code_aliases`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptcontent = false;
        });
    }

    // Add code alias to script.
    function addCodeAlias(codealias, callback) {
      $http
        .post(`/api/scripts/${codealias.SCRIPT_ID}/code_aliases`, codealias)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          let message = "Error! Adding Code Alias failed: ";
          if (data.errortext) {
            message += data.errortext;
          } else {
            message += status;
          }
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    }

    // Update selected script code aliases from the database
    function updateScriptCodeAlias(codealias, callback) {
      $http
        .put(`/api/scripts/${codealias.SCRIPT_ID}/code_aliases/${codealias.SCRIPT_ALIAS_ID}`, codealias)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    }

    // Load one selected script flow from the database
    function loadScriptFlowByID(scriptID, callback) {
      loading.scriptcontent = true;
      $http
        .get(`/api/scripts/${scriptID}/flows`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptcontent = false;
        });
    }

    // Load one selected script phrase aliases from the database (selected language)
    function loadScriptPhraseAliasesByID(scriptID, lang, callback) {
      loading.scriptcontent = true;
      $http
        .get(`/api/scripts/${scriptID}/phrase_aliases?lang=${lang}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptcontent = false;
        });
    }

    // Load one selected script phrase aliases from the database (all languages)
    function loadAllScriptPhraseAliasesByID(scriptID, callback) {
      loading.scriptcontent = true;
      $http
        .get(`/api/scripts/${scriptID}/phrase_aliases`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptcontent = false;
        });
    }

    // Load one selected script titles by language
    function loadScriptTitlesByID(scriptID, lang, callback) {
      loading.scriptcontent = true;
      $http
        .get(`/api/scripts/${scriptID}/titles/${lang}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptcontent = false;
        });
    }

    // Load one selected script title history by language
    function loadScriptTitlesHistoryByID(rowID, scriptID, callback) {
      $http
        .get(`/api/scripts/${scriptID}/titles/${rowID}/history`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    }

    // Load one selected script javascript from the database
    function loadScriptJSByID(scriptID, callback) {
      loading.scriptmeta = true;
      $http
        .get(`/api/scripts/${scriptID}/javascript`)
        .success((data, status) => {
          let cleandata = "";
          if (data && data[0]) {
            cleandata = data[0];
            if (data[0].JS_FOUNDED_TIMESTAMP) {
              data[0].JS_FOUNDED_TIMESTAMP = cleandata.JS_FOUNDED_TIMESTAMP.substring(
                0,
                10,
              );
            }
            if (data[0].JS_EDITED_TIMESTAMP) {
              data[0].JS_EDITED_TIMESTAMP = cleandata.JS_EDITED_TIMESTAMP.substring(
                0,
                10,
              );
            }
          }
          if (callback) {
            callback(cleandata, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.scriptmeta = false;
        });
    }

    // Load relations to returning message in script
    function loadMessageRelations(returningMessage, callback) {
      const scriptId = returningMessage.SCRIPT_ID;
      const messageId = returningMessage.SMID;

      $http
        .get(`/api/scripts/${scriptId}/messages/${messageId}/relations/`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    }

    function loadCodeAliasScripts(alias, callback) {
      $http
        .get(`/api/aliases/${alias}/scripts`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => { });
    }

    // Load one selected script phrase aliases from the database (selected language)
    function loadScriptResponseMessageById(scriptID, callback) {
      loading.scriptcontent = true;
      $http
        .get(`/api/scripts/${scriptID}/response_message`)
        .success(callback)
        .error((_, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
        })
        .finally(() => {
          loading.scriptcontent = false;
        });
    }

    function addScript(callback) {
      $http.post("/api/scripts", {}).then(
        (res) => {
          const message = `New script created, ID: ${res.data.ID}`;
          Flash.create("success", message, "basicAlert");
          callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Creating new script failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          callback(res.data, res.status);
        },
      );
    }

    function deleteScript(scriptID, callback) {
      $http.delete(`/api/scripts/${scriptID}`).then(
        (res) => {
          const message = `Script removed, ID: ${scriptID}`;
          Flash.create("success", message, "basicAlert");
          callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Removing a script failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          callback(res.data, res.status);
        },
      );
    }

    function updateScriptMeta(newData, callback) {
      newData.KEYWORDS = ";";
      for (let i = 0; newData.KEYWORDS_SPLITTED.length > i; i++) {
        newData.KEYWORDS += `${newData.KEYWORDS_SPLITTED[i].text};`;
      }
      newData.EVIDENCE_TEAMS = ",";
      for (let i = 0; newData.EVIDENCE_TEAMS_SPLITTED.length > i; i++) {
        newData.EVIDENCE_TEAMS += `${newData.EVIDENCE_TEAMS_SPLITTED[i].text},`;
      }
      $http.put(`/api/scripts/${newData.ID}`, newData).then(
        (res) => {
          const message = `Update successful for script ID: ${newData.ID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating script meta failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptStatus(scriptId, STATUS, callback) {
      $http.put(`/api/scripts/${scriptId}/status`, { STATUS }).then(
        (res) => {
          Flash.create("success", "Script status updated.", "basicAlert");
          callback(res.data, res.status);
        },
        (res) => {
          Flash.create("danger", `Error! Script status update failed with error code ${res.status}.`);
        },
      );
    }

    function updateScriptTitle(newData, callback) {
      newData.LANG = $rootScope.loggedUser.language;
      $http.put(`/api/scripts/${newData.SCRIPT_ID}/titles/${newData.ID}`, newData).then(
        (res) => {
          const updatedId = newData.ID || res.data.NEWID;
          const message = `Update successful for title ID: ${updatedId}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating title failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptTitleModal(newData, callback) {
      newData.LANG = newData.ABBREVIATION;
      $http.put(`/api/scripts/${newData.SCRIPT_ID}/titles/${newData.ID}`, newData).then(
        (res) => {
          const message = `Update successful for title translations, script ID: ${newData.SCRIPT_ID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating title failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateRegionalCountries(countries, scriptid, callback) {
      $http.put(`/api/scripts/${scriptid}/countries`, countries).then(
        (res) => {
          const message = `Update successful for regional usage for script ID: ${scriptid}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Updating regional usage failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateBlockings(blockings, scriptid, callback) {
      $http.put(`/api/scripts/${scriptid}/blockings`, blockings).then(
        (res) => {
          const message = `Update successful for blockings for script ID: ${scriptid}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating blockings failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptSummary(summary, scriptid, callback) {
      summary.SCRIPT_ID = scriptid;
      $http.put(`/api/scripts/${scriptid}/summaries/${summary.ID}`, summary).then(
        (res) => {
          const message = `Update successful for summary usage for script ID: ${scriptid}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating summary failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptRisk(risk, callback) {
      $http.put(`/api/scripts/${risk.SCRIPT_ID}/risks/${risk.ID}`, risk).then(
        (res) => {
          const message = `Update successful for risk for script ID: ${risk.SCRIPT_ID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating risk failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptSummaryField(fieldName, record) {
      const field = fieldName.toLowerCase();
      $http.put(`/api/scripts/${record.SCRIPT_ID}/summaries/${record.ID}/${field}`, record).then(
        () => {
          const message = `Update successful for ${field} for script ID: ${record.SCRIPT_ID}`;
          Flash.create("success", message, "basicAlert");
        },
        (res) => {
          const message = `Error! Updating ${field} failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
        },
      );
    }

    function updateScriptEvidence(evidence, callback) {
      $http.put(`/api/scripts/${evidence.SCRIPT_ID}/evidences/${evidence.ID}`, evidence).then(
        (res) => {
          const message = "Update successful for evidence";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Updating evidence failed with error code: ${evidence.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptCochrane(cochrane, callback) {
      $http.put(`/api/scripts/${cochrane.SCRIPT_ID}/cochranes/${cochrane.ID}`, cochrane).then(
        (res) => {
          const message = "Update successful for cochrane";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Updating cochrane failed with error code: ${cochrane.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptEBMGuideline(guideline, callback) {
      $http.put(`/api/scripts/${guideline.SCRIPT_ID}/guidelines/${guideline.ID}`, guideline).then(
        (res) => {
          const message = "Update successful for EBM guideline";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Updating EBM guideline failed with error code: ${guideline.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptJournal(journal, callback) {
      $http.put(`/api/scripts/${journal.SCRIPT_ID}/journals/${journal.ID}`, journal).then(
        (res) => {
          const message = "Update successful for Journal";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating Journal failed with error code: ${journal.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptWWWlink(link, callback) {
      $http.put(`/api/scripts/${link.SCRIPT_ID}/www_links/${link.ID}`, link).then(
        (res) => {
          const message = "Update successful for www-link";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating www-link failed with error code: ${link.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptOtherEvidence(evidence, callback) {
      $http.put(`/api/scripts/${evidence.SCRIPT_ID}/conventions/${evidence.ID}`, evidence).then(
        (res) => {
          const message = "Update successful for evidence";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Updating evidence failed with error code: ${evidence.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptAnyMessage(message, callback) {
      $http.put(`/api/scripts/${message.SCRIPT_ID}/messages/${message.MESSAGE_ID}/all/${message.LANG}`, message)
        .then(
          (res) => {
            Flash.create("success", "Message updated successfully.", "basicAlert");
            callback(res.data, res.status);
          },
          () => {
            Flash.create("danger", "Updating message failed!", "basicAlert");
          },
        );
    }

    function updateScriptTypeMessage(type, message) {
      $http.put(`/api/scripts/${message.SCRIPT_ID}/messages/${message.ID}/${type.toLowerCase()}`, message).then(
        () => {
          const alert = `Update successful for ${type} Message`;
          Flash.create("success", alert, "basicAlert");
        },
        (res) => {
          const alert = `Error! Updating ${type} Message failed with error code: ${res.status}`;
          Flash.create("danger", alert, "basicAlert");
        },
      );
    }

    function updateScriptMessage(message, callback) {
      $http.put(`/api/scripts/${message.SCRIPT_ID}/messages/${message.SMID}`, message).then(
        (res) => {
          const messageText = "Update successful for Message data";
          Flash.create("success", messageText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const messageText =
            `Error! Updating Message data failed with error code: ${message.status}`;
          Flash.create("danger", messageText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptMessageRelations(
      relations,
      scriptid,
      messageid,
      callback,
    ) {
      $http.put(`/api/scripts/${scriptid}/messages/${messageid}/relations`, relations).then(
        (res) => {
          const message =
            `Update successful for message relations for script ID: ${scriptid}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Updating message relations failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptPhraseAliases(items, callback) {
      const body = {
        items,
      };

      $http.put(`/api/scripts/${$rootScope.pageID}/phrase_aliases`, body).then(
        (res) => {
          const commentText = "Update successful for script phrase aliases";
          Flash.create("success", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const commentText = `Error! Updating script phrase aliases failed with error code: ${res.status}`;
          Flash.create("danger", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptResponseMessage(scriptId, messageId, callback) {
      $http
        .put(`/api/scripts/${scriptId}/response_message`, { messageId })
        .success((_, status) => {
          const messageText = "Update successful for response message";
          Flash.create("success", messageText, "basicAlert");
          callback(status);
        })
        .error((_, status) => {
          const messageText = `Error! Updating response message failed with error code: ${status}`;
          Flash.create("danger", messageText, "basicAlert");
        });
    }

    function deleteScriptPhraseAlias(id, callback) {
      $http.delete(`/api/scripts/${$rootScope.pageID}/phrase_aliases/${id}`).then(
        (res) => {
          const commentText = "Remove successful for script phrase alias";
          Flash.create("success", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const commentText = `Error! Removing script phrase alias failed with error code: ${res.status}`;
          Flash.create("danger", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateScriptFlow(items, callback) {
      const body = {
        items,
      };

      $http.put(`/api/scripts/${$rootScope.pageID}/flows`, body).then(
        (res) => {
          const commentText = "Update successful for script flow";
          Flash.create("success", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const commentText = `Error! Updating script flow failed with error code: ${res.status}`;
          Flash.create("danger", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptFlowItem(id, callback) {
      $http.delete(`/api/scripts/${$rootScope.pageID}/flows/${id}`).then(
        (res) => {
          const commentText = "Remove successful for script flow item";
          Flash.create("success", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const commentText = `Error! Removing script flow item failed with error code: ${res.status}`;
          Flash.create("danger", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptCodeAlias(alias, callback) {
      $http.delete(`/api/scripts/${alias.SCRIPT_ID}/code_aliases/${alias.SCRIPT_ALIAS_ID}`, alias).then(
        (res) => {
          const message = "Remove successful for code alias";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Removing code alias failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function unlinkAllScriptCodeAlias(aliasId, callback) {
      $http.delete(`/api/scripts/code_aliases/${aliasId}`).then(
        (res) => {
          const message = "Remove successful for code alias";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Removing code alias failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptRisk(risk, callback) {
      $http.delete(`/api/scripts/${risk.SCRIPT_ID}/risks/${risk.ID}`, risk).then(
        (res) => {
          const message = "Deletion successful for risk";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Deleting risk failed with error code: ${risk.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptEvidence(evidence, callback) {
      $http.delete(`/api/scripts/${evidence.SCRIPT_ID}/evidences/${evidence.ID}`, evidence).then(
        (res) => {
          const message = "Deletion successful for graded evidence";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Deleting evidence failed with error code: ${evidence.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptCochrane(cochrane, callback) {
      $http.delete(`/api/scripts/${cochrane.SCRIPT_ID}/cochranes/${cochrane.ID}`, cochrane).then(
        (res) => {
          const message = "Deletion successful for cochrane review";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Deleting cochrane review failed with error code: ${cochrane.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptEBM(ebm, callback) {
      $http.delete(`/api/scripts/${ebm.SCRIPT_ID}/guidelines/${ebm.ID}`, ebm).then(
        (res) => {
          const message = "Deletion successful for ebm guideline";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Deleting ebm guideline failed with error code: ${ebm.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptJournal(journal, callback) {
      $http.delete(`/api/scripts/${journal.SCRIPT_ID}/journals/${journal.ID}`, journal).then(
        (res) => {
          const message = "Deletion successful for journal article";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Deleting journal article failed with error code: ${journal.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptwwwlink(wwwlink, callback) {
      $http.delete(`/api/scripts/${wwwlink.SCRIPT_ID}/www_links/${wwwlink.ID}`, wwwlink).then(
        (res) => {
          const message = "Deletion successful for internet site";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Deleting internet site failed with error code: ${wwwlink.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptOtherEvidence(otherevidence, callback) {
      $http.delete(`/api/scripts/${otherevidence.SCRIPT_ID}/conventions/${otherevidence.ID}`, otherevidence).then(
        (res) => {
          const message = "Deletion successful for other evidence";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message =
            `Error! Deleting other evidence failed with error code: ${otherevidence.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteScriptMessage(message, callback) {
      $http.delete(`/api/scripts/${message.SCRIPT_ID}/messages/${message.SMID}`, message).then(
        (res) => {
          const messageText = "Deletion successful for message";
          Flash.create("success", messageText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const messageText = `Error! Deleting message failed with error code: ${message.status}`;
          Flash.create("danger", messageText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    const reactivateScriptMessage = ({ SCRIPT_ID, SMID }, callback) =>
      $http
        .put(`/api/scripts/${SCRIPT_ID}/messages/${SMID}/status`, {})
        .success((data, status) => {
          const successMessage = "Message reactivated successfully";
          Flash.create("success", successMessage, "basicAlert");
          return callback(data, status);
        })
        .error((data, status) => {
          const errorMessage = `Reactivating message failed with error code: ${status}`;
          Flash.create("danger", errorMessage, "basicAlert");
          return callback(data, status);
        });

    function addScriptJSByScriptId(scriptId, payload, callback) {
      $http
        .post(`/api/scripts/${scriptId}/javascript`, payload)
        .success((data, status) => {
          const message = "Javascript saved successfully";
          Flash.create("success", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          Flash.create("danger", `Failed to save Javascript: ${data.errortext}`, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        });
    }

    function updateScriptJSByScriptId(scriptId, payload, callback) {
      $http
        .put(`/api/scripts/${scriptId}/javascript`, payload)
        .success((data, status) => {
          const message = "Javascript updated successfully";
          Flash.create("success", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          Flash.create("danger", `Failed to update Javascript: ${data.errortext}`, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        });
    }

    function addOrUpdateJSByScriptId(scriptId, { CODE }, isExistsInDB, VERSION, callback) {
      if (isExistsInDB) {
        updateScriptJSByScriptId(scriptId, { CODE, VERSION }, callback);
      } else {
        addScriptJSByScriptId(scriptId, { CODE }, callback);
      }
    }

    function publishJavascriptVersion(scriptId, payload, callback) {
      $http
        .post(`api/scripts/${scriptId}/javascript/versions`, payload)
        .success((data, status) => {
          const message = "Javascript published successfully";
          Flash.create("success", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Updating data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        });
    }

    function loadPublishedVersions(scriptId, callback) {
      $http
        .get(`api/scripts/${scriptId}/javascript/versions`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        });
    }
    function loadSavedVersions(scriptId, callback) {
      $http
        .get(`api/scripts/${scriptId}/javascript/saved_versions`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        });
    }

    function markSaved(field) {
      $rootScope.changedFields.delete(field);
    }

    function getReminderTestCollection(callback) {
      $http
        .get("api/scripts/generate/reminder_tests")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        });
    }

    return {
      addScript,
      deleteScript,
      getScripts: scripts,
      getReminderTestCollection,
      loading,
      loadScripts,
      loadScriptMetaByID,
      loadAuditLogById,
      loadScriptStatusHistoryByID,
      loadScriptSummaryByID,
      loadScriptMetadataHistoryByType,
      loadScriptRiskByID,
      loadScriptEvindenceByID,
      loadScriptEvindenceTextByID,
      loadScriptCochraneByID,
      loadScriptCochraneTextByID,
      loadScriptEBMGuidelinesByID,
      loadScriptEBMGuidelinesTextByID,
      loadScriptJournalArticlesByID,
      loadScriptJournalArticlesTextByID,
      loadScriptOtherEvidenceByID,
      loadScriptWWWlinksByID,
      loadScriptReturningMessagesByID,
      loadScriptMessageHistory,
      loadScriptCodeAliasesByID,
      loadScriptPhraseAliasesByID,
      loadScriptResponseMessageById,
      loadAllScriptPhraseAliasesByID,
      loadMessageRelations,
      loadScriptFlowByID,
      loadScriptTitlesByID,
      loadScriptTitlesHistoryByID,
      loadScriptJSByID,
      loadCodeAliasScripts,
      loadPublishedVersions,
      loadSavedVersions,
      publishJavascriptVersion,
      updateScriptMeta,
      updateScriptStatus,
      updateScriptTitle,
      updateScriptTitleModal,
      updateRegionalCountries,
      updateScriptAnyMessage,
      updateScriptTypeMessage,
      updateScriptCodeAlias,
      addCodeAlias,
      addOrUpdateJSByScriptId,
      updateScriptMessage,
      updateBlockings,
      updateScriptSummary,
      updateScriptRisk,
      updateScriptSummaryField,
      updateScriptEvidence,
      updateScriptCochrane,
      updateScriptEBMGuideline,
      updateScriptJournal,
      updateScriptWWWlink,
      updateScriptOtherEvidence,
      updateScriptMessageRelations,
      updateScriptPhraseAliases,
      updateScriptResponseMessage,
      deleteScriptPhraseAlias,
      updateScriptFlow,
      deleteScriptFlowItem,
      deleteScriptCodeAlias,
      unlinkAllScriptCodeAlias,
      deleteScriptRisk,
      deleteScriptEvidence,
      deleteScriptCochrane,
      deleteScriptEBM,
      deleteScriptJournal,
      deleteScriptwwwlink,
      deleteScriptOtherEvidence,
      deleteScriptMessage,
      reactivateScriptMessage,
      markSaved,
    };
  },
]);
